// extracted by mini-css-extract-plugin
export default {"area":"bHUfzB","mobile":"sDnoP6","label":"RJLl0N","occupiedArea":"AX9V1X"};